module.exports = __webpack_public_path__ + "static/media/cash-payment.29d2b450.svg";